// src/components/card/FeelingRoom.tsx

import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  List,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { FolderId, SensorId, SensorRecord, SensorType } from '@/types/domain'

import { FeelingRoomSensor, IntervalAlert } from '..'
import { getStatusColor, SVGStatus } from '../../api'
import { useFeelingSensors } from '../../hooks'

type FeelingRoomProps = {
  id: FolderId
  type: SensorType
}

export const FeelingRoom = ({ id, type }: FeelingRoomProps) => {
  const navigate = useNavigate()

  const fSensors: SensorRecord[] = useFeelingSensors(id)
  const roomSensors: SensorRecord[] = fSensors
    .filter(f => f.name === type)
    .sort()
  const status = getStatusColor(roomSensors)

  const avatar = (
    <Avatar>
      <SVGStatus type={'feeling'} status={status} />
    </Avatar>
  )

  return (
    <Card variant={'feeling'}>
      <CardHeader
        avatar={avatar}
        slotProps={{ title: { variant: 'h6' } }}
        title={type}
        variant={'feeling'}
      />

      <CardContent sx={{ p: '0 !important' }}>
        <Collapse in={true}>
          {/* display interval alert, if applicable  */}
          <IntervalAlert title={type} sensors={fSensors} />

          <List>
            {roomSensors.map(item => {
              const { entity_id } = item
              const sId: SensorId = Number(entity_id)
              const pathname: string = `/folder/${id}/home/correlation`
              const onClick = () =>
                navigate(pathname, { state: { sensorId: sId } })

              return (
                <FeelingRoomSensor
                  id={id}
                  key={sId}
                  onClick={onClick}
                  sensorId={sId}
                />
              )
            })}
          </List>
        </Collapse>
      </CardContent>
    </Card>
  )
}
